<h2 mat-dialog-title class="text-center">Calculation modal</h2>
<mat-dialog-content>
  <app-server-response *ngIf="serverResponse" [response]="serverResponse"></app-server-response>
  <div [hidden]="!isLoading" class="col-12">
    <mat-spinner class="m-0 m-auto"></mat-spinner>
  </div>
  <form *ngIf="form" [formGroup]="form" class="p-2">
    <div class="row">
      <!-- Payment Plan Type -->
      <div class="col-6 col-lg">
        <app-input type="number" formControlName="initial_balance" appearance="outline" fullWidth="false"
                   [label]="'CASE_CREDITOR.model.confirmed_debt' | translate" [extraLabel]="true">
        </app-input>
        <app-input type="number" formControlName="negotiated_amount" appearance="outline" fullWidth="false"
                   [label]="'CASE_CREDITOR.calculation_modal.form.settlement_offer' | translate" [extraLabel]="true"
                   [minAmount]="'VALIDATORS.negotiatedTooHigh' | translate">
        </app-input>
        <app-input type="number" formControlName="discount" appearance="outline" fullWidth="false"
                   [label]="'CASE_CREDITOR.calculation_modal.form.discount' | translate" [extraLabel]="true">
        </app-input>
        <app-input type="number" formControlName="available_funds" appearance="outline" fullWidth="false"
                   [label]="'CASE_CREDITOR.calculation_modal.form.available_funds' | translate" [extraLabel]="true">
        </app-input>
        <app-input type="number" formControlName="top_up" appearance="outline" fullWidth="false"
                   [label]="'CASE_CREDITOR.calculation_modal.form.top_up' | translate" [extraLabel]="true">
        </app-input>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close color="primary">Close</button>
  <button mat-raised-button color="primary" (click)="submitForm(form)">
    {{ 'SHARED.save' | translate }}
  </button>
</mat-dialog-actions>
